import { Autocomplete, Avatar, Box, Button, Card, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Step, StepButton, Stepper, Switch, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Paper from "@mui/material/Paper";
import React from "react";

export const AddRecordsDialog = ({ recordsOpen, handleRecordsClose, activeStep, isSmallScreen, steps, completed, handleStep, allStepsCompleted, showAlert, newRecord, handleInputChange, fullNameError, numberError, emailError, experienceError, candidateOptionValues, convertSource, employeesList, editedData, editableRowIndex, convertStatus, cvError, handleFileSelect, totalSteps, handleBack, handleAddRecord, sourceError, statusError, setNewRecord, setSourceError, setStatusError, advertisementss, handleJobOpenings, jdError }) => {
  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            width: "100%",
            maxWidth: "none",
            borderRadius: "10px",
            paddingBottom: "20px"
          },
        }}
        open={recordsOpen}
        onClose={handleRecordsClose}
      >

        <Box>
          <Stepper nonLinear activeStep={activeStep} orientation={isSmallScreen ? 'vertical' : 'horizontal'} sx={{
            background: "none",
            px: isSmallScreen ? "50px" : "250px",
            "& .MuiStepIcon-root.Mui-active": {
              background: "#66AEF2 !important",
              fill: " #66AEF2 !important",
              stroke: "none !important",
            },
            "& .MuiStepIcon-root": {
              background: " #9FC9FF !important",
              fill: "#9FC9FF !important",
              stroke: "none !important",
              fontSize: "50px !important",
              width: "1.8125rem !important",
              height: "1.8125rem !important",
            },
            "& .MuiStepConnector-line": {
              color: "#9FC9FF",
              display: "flex",
              justifyContent: "center",
            },
            "& .MuiStepLabel-label": {
              marginBottom: "0.5rem",
            },
            "& .MuiStepButton-root": {
              padding: "9px 16px !important",
            },
          }}>
            {steps.map((label, index) => (
              <Step key={label} completed={completed[index]}>
                <StepButton color="inherit" onClick={handleStep(index)}>
                  <span style={{ color: "#000" }}>{label}</span>
                </StepButton>
              </Step>
            ))}
            <IconButton sx={{ position: 'absolute', right: 15, top: 18 }}
              onClick={() => {
                // setJobAdvertisementPayload({});
                handleRecordsClose(false);
                // clearValidation();
              }}
            >
              <ClearIcon />
            </IconButton>
          </Stepper>
          <div>
            {allStepsCompleted() ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                  <Box sx={{ flex: '1 1 auto' }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Box>
                  {/* Render content based on activeStep */}
                  {activeStep === 0 && (
                    <>

                      {showAlert && (
                        <MDAlert
                          color="primary"
                          dismissible
                          onClick={() => {
                            setShowAlert(null);
                          }}
                        >
                          {alertContent(showAlert)}
                        </MDAlert>
                      )}

                      <DialogTitle>Add Candidate</DialogTitle>
                      <DialogContent style={{ maxHeight: "70vh", padding: "0px 50px" }}>
                        <Grid container spacing={3}>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              id="name"
                              label="Name"
                              type="text"
                              fullWidth
                              variant="standard"
                              name="full_name"
                              value={newRecord.full_name}
                              onChange={handleInputChange}
                              required
                              error={!!fullNameError}
                              helperText={fullNameError}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              id="number"
                              label="Number"
                              type="number"
                              fullWidth
                              variant="standard"
                              name="mobile"
                              value={newRecord.mobile}
                              onChange={handleInputChange}
                              required
                              error={!!numberError}
                              helperText={numberError}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              id="email"
                              label="Email"
                              type="email"
                              fullWidth
                              variant="standard"
                              name="email"
                              value={newRecord.email}
                              onChange={handleInputChange}
                              required
                              error={!!emailError}
                              helperText={emailError}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              id="experience"
                              label="Experience"
                              type="number"
                              fullWidth
                              variant="standard"
                              name="experience"
                              value={newRecord.experience}
                              onChange={handleInputChange}
                              required
                              error={!!experienceError}
                              helperText={experienceError}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              options={
                                candidateOptionValues?.source
                                  ? Object.entries(candidateOptionValues?.source).map(
                                    ([key, value]) => ({ value: key, label: value })
                                  )
                                  : []
                              }
                              value={convertSource(newRecord.source)}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setNewRecord((state) => ({
                                    ...state,
                                    source: newValue?.value,
                                  }));
                                }
                                setSourceError("");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Source"
                                  variant="standard"
                                  fullWidth
                                  error={!!sourceError}
                                  helperText={sourceError}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              id="recruiter"
                              options={employeesList}
                              value={editedData[editableRowIndex]?.recruiter}
                              getOptionLabel={(option) =>
                                Array.isArray(option)
                                  ? option.map(
                                    (item) => item.user.firstname + " " + item.user.lastname
                                  )
                                  : option.user.firstname + " " + option.user.lastname
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  name="recruiter"
                                  label="Recruiter"
                                  variant="standard"
                                />
                              )}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  const selectedValues = Array.isArray(newValue)
                                    ? newValue.map((v) => v.id)
                                    : [newValue.id];
                                  setNewRecord((state) => ({
                                    ...state,
                                    recruiter: selectedValues,
                                  }));
                                }
                              }}
                            />
                          </Grid>


                          <Grid item xs={6}>
                            <Autocomplete
                              options={
                                candidateOptionValues?.status
                                  ? Object.entries(candidateOptionValues?.status).map(
                                    ([key, value]) => ({ value: key, label: value })
                                  )
                                  : []
                              }
                              value={convertStatus(newRecord.status)}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setNewRecord((state) => ({
                                    ...state,
                                    status: newValue?.value,
                                  }));
                                }
                                setStatusError("");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Status"
                                  variant="standard"
                                  fullWidth
                                  error={!!statusError}
                                  helperText={statusError}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              error={!!cvError}
                              helperText={cvError}
                              label="Resume"
                              variant="standard"
                              fullWidth
                              type="file"
                              onChange={handleFileSelect}
                            />
                          </Grid>
                        </Grid>
                      </DialogContent>
                    </>

                  )}
                  {activeStep === 1 && (
                    <>
                      <Grid container spacing={2} marginTop={2} alignItems="center" sx={{ padding: "0 20px" }}>
                        <Grid item xs={12}>
                          <MDTypography sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                            Select Job Opening
                          </MDTypography>
                        </Grid>

                        <Grid item xs={12} md={8} lg={6}>
                          <Autocomplete
                            name="jd"
                            multiple
                            options={advertisementss}
                            getOptionLabel={(option) => option?.position}
                            // value={newRecord.jd?.length > 0 ? newRecord?.jd : advertisementss.filter((item) => item?.position === advertisement?.position)}
                            onChange={(event, value) => {
                              if (value) {
                                setNewRecord((state) => ({
                                  ...state,
                                  jd: value,
                                }));
                              }
                              setStatusError("");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                id="autocomplete"
                                label="Job Openings"
                                variant="outlined"
                                error={!!jdError}
                                helperText={jdError}
                                //sx={{
                                //  backgroundColor: '#fff',
                                //  '& .MuiInputBase-root': {
                                //    backgroundColor: '#fff',
                                //  },
                                //  '& .MuiAutocomplete-tag': {
                                //    backgroundColor: '#F9F9F9',
                                //    color: 'inherit',
                                //  },
                                //  '& .MuiAutocomplete-clearIndicator': {
                                //    backgroundColor: '#fff',
                                //  },
                                //  '& .MuiAutocomplete-tag .MuiSvgIcon-root': {
                                //    color: "#000000",
                                //  },
                                //}}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "20px", mt: 2 }}>
                        {Array.isArray(newRecord?.jd) && newRecord?.jd?.map((item, index) => (
                          <Card sx={{ padding: "20px", width: "30%", flex: "1 1 calc(30% - 20px)" }} key={index}>
                            <Box sx={{ display: "flex", gap: "20px" }}>
                              <Box>
                                <Avatar alt="Profile Picture" sx={{ width: 50, height: 50 }} />
                              </Box>
                              <Box>
                                <Typography mt={1} sx={{ fontWeight: "500", fontSize: "19px" }}>
                                  {item.position}
                                </Typography>
                              </Box>
                            </Box>
                            <Box sx={{ borderBottom: "1px solid gray", margin: "10px 0", width: "100%", alignSelf: "center" }} />
                            <Box>
                              <Typography sx={{ fontSize: "13px" }}>
                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                  Education :
                                </Typography>
                                {item.education}
                              </Typography>
                              <Typography sx={{ fontSize: "13px" }}>
                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                  Experience :
                                </Typography>
                                {item.experience}
                              </Typography>
                              <Typography sx={{ fontSize: "13px" }}>
                                <Typography sx={{ fontWeight: 400, fontSize: "15px", padding: "0 10px" }} component="span">
                                  Vacancy :
                                </Typography>
                                {item.vacancy}
                              </Typography>
                            </Box>
                          </Card>
                        ))}
                      </Box>
                    </>
                  )}
                  {/* {activeStep === 2 && (
                                            <>
                                                <DialogActions>
                                                    <MDButton
                                                        variant="gradient"
                                                        color="dark"
                                                        onClick={handleRecordsClose}
                                                    >
                                                        Cancel
                                                    </MDButton>
                                                    <MDButton variant="gradient" color="dark" onClick={handleAddRecord}>
                                                        Add Candidate
                                                    </MDButton>
                                                </DialogActions>
                                            </>
                                        )} */}
                </Box>
                <DialogActions
                  sx={{
                    display: "flex",
                    flexDirection: isSmallScreen ? "column" : "row",
                    alignItems: isSmallScreen ? "center" : "flex-start",
                    justifyContent: "space-between",
                    padding: isSmallScreen ? "0px 20px" : "0px 60px",
                    gap: isSmallScreen ? 2 : 0,
                  }}
                >
                  <Box>
                    {activeStep !== totalSteps() - 1 && (
                      <Box sx={{
                        display: "flex",
                        // justifyContent: "space-between",
                        justifyContent: isSmallScreen ? "center" : "space-between",
                        width: "100%",
                        padding: "0px 15px",
                        marginTop: isSmallScreen ? "90px" : "15px",
                      }}>
                        <MDButton
                          variant="gradient"
                          color="dark"
                          onClick={() => {
                            // setJobAdvertisementPayload({});
                            handleRecordsClose(false);
                            // clearValidation();
                          }}
                        >
                          Cancel
                        </MDButton>
                      </Box>
                    )}
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: isSmallScreen ? "column" : "row",
                    pt: 2,
                  }}>
                    <MDButton
                      variant="gradient"
                      color="dark"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Back
                    </MDButton>
                    <Box sx={{ flex: '1 1 auto' }} />

                    {activeStep === totalSteps() - 1 ? (
                      <>
                        {/* <Box sx={{ display: "flex", justifyContent: "right", m: 2 }}> */}
                        <MDButton variant="gradient" color="dark" onClick={handleJobOpenings}>Submit</MDButton>
                        {/* </Box> */}
                      </>
                    ) : (
                      <>
                        <MDButton
                          variant="gradient"
                          color="dark"
                          disabled={activeStep === totalSteps() - 1}
                          onClick={handleAddRecord}
                          // onClick={handleNext}
                          sx={{
                            mr: 1, marginTop: isSmallScreen ? "20px" : "0px",
                          }}
                        >
                          Continue
                        </MDButton>
                      </>
                    )}


                    {/* {activeStep !== steps.length &&
                                                      (completed[activeStep] ? (
                                                        <Typography variant="caption" sx={{ display: 'inline-block' }}>
                                                          Step {activeStep + 1} already completed
                                                        </Typography>
                                                      ) : (
                                                        <Button onClick={handleComplete}>
                                                          {completedSteps() === totalSteps() - 1
                                                            ? 'Finish'
                                                            : 'Complete Step'}
                                                        </Button>
                                                      ))} */}
                  </Box>
                </DialogActions>

              </React.Fragment>
            )}
          </div>
        </Box>
      </Dialog>
    </>
  )
}

export const InterviewsDialog = ({ interviewDialog, permissions, modulePermissions, candidate, currentCandidateIndex, handleInterviewClose, handleInterivewCancelClick, handleOnInterviewerNameClick, handleDeleteInterviewRecord, getEmployeeNameById, getTimeFromDateTime, getDateFromDateTime }) => {
  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: "aliceBlue",
            boxShadow: "none",
            width: "70%",
            height: "600px",
            maxWidth: "none",
            borderRadius: "10px",
            padding: "20px",
          },
        }}
        open={interviewDialog}
        onClose={() => {
          handleInterviewClose();
          handleInterivewCancelClick();
        }}
      >
        <DialogTitle>
          <Typography variant="h5">Interview Details</Typography>
        </DialogTitle>
        <DialogContent style={{ padding: "30px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableRow>
                {/* <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "white" }}>
                    S.No
                  </Typography>
                </TableCell> */}
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Interviewer Name
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Interview Time
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Interview Date
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Ratings
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Feedback
                  </Typography>
                </TableCell>
                <TableCell style={{ padding: "8px" }}>
                  <Typography variant="h6" style={{ color: "black" }}>
                    Experience
                  </Typography>
                </TableCell>
                {(permissions?.includes(
                  modulePermissions?.interview_update_permission
                ) ||
                  permissions?.includes(
                    modulePermissions?.interview_delete_permission
                  )) && (
                    <TableCell style={{ padding: "8px" }}>
                      <Typography variant="h6" style={{ color: "black" }}>
                        Actions
                      </Typography>
                    </TableCell>
                  )}
              </TableRow>
              <TableBody>
                {candidate[currentCandidateIndex]?.interviews?.map(
                  (record, index) => (
                    // index === editableInterviewRowIndex ? (
                    //   <TableRow key={record.id}>

                    //     <TableCell>
                    //       <Autocomplete
                    //         id="interviewerName"
                    //         options={employeesList}
                    //         multiple
                    //         getOptionLabel={(option) =>
                    //           option.user.firstname + " " + option.user.lastname
                    //         }
                    //         value={employeesList.filter((v) =>
                    //           editedInterviewData?.interviewer?.some(
                    //             (a) => v.id == a
                    //           )
                    //         )}
                    //         renderInput={(params) => (
                    //           <TextField
                    //             {...params}
                    //             fullWidth
                    //             name="interviewerName"
                    //             label="Interviewer Name"
                    //             variant="standard"
                    //           />
                    //         )}
                    //         onChange={(event, newValue) => {
                    //           if (newValue) {
                    //             setEditedInterviewData((state) => ({
                    //               ...state,
                    //               interviewer: newValue?.map((v) => v.id),
                    //             }));
                    //           }
                    //         }}
                    //       />
                    //     </TableCell>
                    //     <TableCell>
                    //       <TextField
                    //         variant="standard"
                    //         InputLabelProps={{ shrink: true }}
                    //         margin="dense"
                    //         id="interviewTime"
                    //         type="time"
                    //         fullWidth
                    //         name="interviewTime"
                    //         value={moment(editedInterviewData.datetime).format(
                    //           "HH:mm"
                    //         )}
                    //         onChange={(event) => {
                    //           var dateTime = moment(
                    //             getDateFromDateTime(
                    //               editedInterviewData.datetime
                    //             ) + event.target.value,
                    //             +event.target.value,
                    //             "DD-MM-YYYY HH:mm:ss"
                    //           ).format();

                    //           setEditedInterviewData((state) => ({
                    //             ...state,
                    //             datetime: dateTime,
                    //           }));
                    //         }}
                    //         InputProps={{
                    //           classes: {
                    //             input: "input-field",
                    //           },
                    //           placeholder: "",
                    //         }}
                    //       />
                    //     </TableCell>
                    //     <TableCell>
                    //       <TextField
                    //         variant="standard"
                    //         InputLabelProps={{ shrink: true }}
                    //         margin="dense"
                    //         id="date"
                    //         type="date"
                    //         fullWidth
                    //         name="interviewDate"
                    //         value={moment(editedInterviewData.datetime).format(
                    //           "YYYY-MM-DD"
                    //         )}
                    //         onChange={(event) => {
                    //           var dateTime = moment(
                    //             event.target.value +
                    //               getTimeFromDateTime(
                    //                 editedInterviewData.datetime
                    //               ),
                    //             "YYYY-MM-DD HH:mm:ss"
                    //           ).format();
                    //           setEditedInterviewData((state) => ({
                    //             ...state,
                    //             datetime: dateTime,
                    //           }));
                    //         }}
                    //       />
                    //     </TableCell>
                    //     <TableCell>
                    //       <Input
                    //         value={editedInterviewData.ratings}
                    //         onChange={(event) => {
                    //           setEditedInterviewData((state) => ({
                    //             ...state,
                    //             ratings: event.target.value,
                    //           }));
                    //         }}
                    //       />
                    //     </TableCell>
                    //     <TableCell>
                    //       <Input
                    //         value={editedInterviewData.feedback}
                    //         onChange={(event) => {
                    //           setEditedInterviewData((state) => ({
                    //             ...state,
                    //             feedback: event.target.value,
                    //           }));
                    //         }}
                    //       />
                    //     </TableCell>
                    //     <TableCell>
                    //       <Input
                    //         value={editedInterviewData.experience}
                    //         onChange={(event) => {
                    //           setEditedInterviewData((state) => ({
                    //             ...state,
                    //             experience: event.target.value,
                    //           }));
                    //         }}
                    //       />
                    //     </TableCell>
                    //     {permissions?.includes(modulePermissions?.interview_update_permission) && (
                    //       <TableCell>
                    //         {permissions?.includes(modulePermissions?.interview_update_permission) && (
                    //           <Tooltip title="Save">
                    //             <IconButton
                    //               size="small"
                    //               aria-label="save"
                    //               onClick={() => {
                    //                 handleInterviewSaveClick();
                    //               }}
                    //             >
                    //               <Check />
                    //             </IconButton>
                    //           </Tooltip>
                    //         )}
                    //         <Tooltip title="Cancel">
                    //           <IconButton
                    //             size="small"
                    //             aria-label="cancel"
                    //             onClick={handleInterivewCancelClick}
                    //           >
                    //             <Cancel />
                    //           </IconButton>
                    //         </Tooltip>
                    //       </TableCell>
                    //     )}
                    //   </TableRow>
                    // ) :
                    <TableRow key={record.interviewerNo}>
                      {/* <TableCell style={{ padding: "10px" }}>
                          {index + 1}
                        </TableCell> */}
                      <TableCell
                        sx={{ cursor: "pointer" }}
                        style={{ padding: "10px", fontWeight: "bold" }}
                        onClick={() => handleOnInterviewerNameClick(record)}
                      >
                        {getEmployeeNameById(record.interviewer)}
                      </TableCell>
                      <TableCell style={{ padding: "10px" }}>
                        {getTimeFromDateTime(record.datetime)}
                      </TableCell>
                      <TableCell style={{ padding: "10px" }}>
                        {getDateFromDateTime(record.datetime)}
                      </TableCell>
                      <TableCell style={{ padding: "10px" }}>
                        {record.rating}
                      </TableCell>
                      <TableCell style={{ padding: "10px" }}>
                        <Input
                          value={record.feedback}
                          disableUnderline
                          inputProps={{ readOnly: true }}
                        />
                      </TableCell>
                      <TableCell style={{ padding: "10px" }}>
                        {record.recruiterName}
                      </TableCell>
                      {(permissions?.includes(
                        modulePermissions?.interview_update_permission
                      ) ||
                        permissions?.includes(
                          modulePermissions?.interview_delete_permission
                        )) && (
                          <TableCell>
                            {permissions?.includes(
                              modulePermissions?.interview_delete_permission
                            ) && (
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      // handleDeleteClick(row);
                                      handleDeleteInterviewRecord(record);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                              )}

                            {/* {permissions?.includes(modulePermissions?.interview_update_permission) && (
                              <Tooltip title="Update">
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    handleEditInterviewRecord(record, index);
                                  }}
                                >
                                  <Edit />
                                </IconButton>
                              </Tooltip>
                            )} */}
                          </TableCell>
                        )}
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
        </DialogContent>
        <DialogActions>
          <MDButton
            color="dark"
            variant="gradient"
            onClick={handleInterviewClose}
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export const CandidateInformationDialog = ({ candidateNameDialog, editedData, editableRowIndex, candidateOptionValues, convertStatus, convertSource, employeeOptions, advertisements, handleFileSelect, detail, permissions, modulePermissions, jdError, handleFieldChange, setJDError, handleCancelClick, setCandidateNameDialog, handleSaveClick, handleDocumentOpen }) => {
  const hasFinalInterview = Array.isArray(detail?.interviews)
    ? detail.interviews.some((interview) => interview?.final_interview)
    : false;
  return (
    <>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: "aliceBlue",
            width: "700px",
            height: "500px",
            maxWidth: "none",
            padding: "20px",
          },
        }}
        open={candidateNameDialog}
        onClose={() => {
          setCandidateNameDialog(false);
        }}
      >
        <DialogTitle>
          <MDTypography>Candidates Information</MDTypography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                // margin="dense"
                id="name"
                label="Name"
                type="text"
                fullWidth
                variant="standard"
                name="full_name"
                value={editedData[editableRowIndex]?.full_name}
                onChange={(event) => handleFieldChange(event, "full_name")}
              // inputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                // margin="dense"
                id="mobile"
                label="Mobile"
                type="text"
                fullWidth
                variant="standard"
                name="mobile"
                value={editedData[editableRowIndex]?.mobile}
                onChange={(event) => handleFieldChange(event, "mobile")}
              // inputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                // margin="dense"
                id="experience"
                label="Experience"
                type="text"
                fullWidth
                variant="standard"
                name="experience"
                value={editedData[editableRowIndex]?.experience}
                onChange={(event) => handleFieldChange(event, "experience")}

              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                // margin="dense"
                id="email"
                label="Email"
                type="text"
                fullWidth
                variant="standard"
                name="email"
                value={editedData[editableRowIndex]?.email}
                onChange={(event) => handleFieldChange(event, "email")}

              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={
                  candidateOptionValues?.status
                    ? Object.entries(candidateOptionValues?.status).map(
                      ([key, value]) => ({ value: key, label: value })
                    )
                    : []
                }
                value={convertStatus(editedData[editableRowIndex]?.status)}
                onChange={(event, newValue) => {
                  handleFieldChange(
                    { target: { value: newValue?.value } },
                    "status"
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="standard"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                options={
                  candidateOptionValues?.status
                    ? Object.entries(candidateOptionValues?.source)?.map(
                      ([key, value]) => ({
                        value: key,
                        label: value,
                      })
                    )
                    : []
                }
                value={convertSource(editedData[editableRowIndex]?.source)}
                onChange={(event, newValue) => {
                  handleFieldChange(
                    { target: { value: newValue?.value } },
                    "source"
                  );
                }}
                // sx={{ marginTop: "-12px" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Source"
                    variant="standard"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} alignSelf={"end"}>
              <Autocomplete
                id="recruiter"
                options={employeeOptions}
                getOptionLabel={(option) => option.label}
                value={
                  editedData[editableRowIndex]?.recruiter
                    ? employeeOptions.find(
                      (option) =>
                        option.value ==
                        editedData[editableRowIndex]?.recruiter
                    )
                    : null
                }
                fullWidth

                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="recruiter"
                    label="Recruiter"
                    variant="standard"

                  />
                )}
                onChange={(event, newValue) => {
                  if (newValue) {
                    const selectedValues = Array.isArray(newValue)
                      ? newValue.map((v) => v.value)
                      : newValue.value;
                    handleFieldChange(
                      { target: { value: selectedValues } },
                      "recruiter"
                    );
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <MDTypography variant="h5" p={2}>
                Candidates
              </MDTypography>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                name="jd"
                options={advertisements}
                getOptionLabel={(e) => e?.position}
                value={
                  editedData[editableRowIndex]?.job_ad
                    ? advertisements.find(
                      (option) =>
                        option.id ==
                        editedData[editableRowIndex]?.job_ad
                    )
                    : null
                }
                onChange={(event, value) => {
                  handleFieldChange(
                    { target: { value: value?.id ?? null } },
                    "job_ad"
                  );

                  setJDError("");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    id="autocomplete"
                    label="Job Openings"
                    type="text"
                    variant="standard"
                    error={!!jdError}
                    helperText={jdError}
                  />
                )}
              />
            </Grid>


            <Grid item xs={6} alignSelf="end">
              <input
                type="file"
                onChange={handleFileSelect}
              ></input>

            </Grid>

            <Grid container item xs={12} sm={6} alignItems="center">
              <Grid item>
                <MDTypography variant="h8">Blacklisted</MDTypography>
              </Grid>
              <Grid item style={{ marginLeft: "10px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={detail.blacklisted}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "blacklist-yes-checkbox" }}

                    />
                  }
                  label="Yes"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!detail.blacklisted}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "blacklist-no-checkbox" }}
                    // style={{ color: '#000' }}
                    />
                  }
                  label="No"
                />
              </Grid>
            </Grid>

            <Grid container item xs={12} sm={6} alignItems="center">
              <Grid item>
                <MDTypography variant="h8">Suspicious</MDTypography>
              </Grid>
              <Grid item style={{ marginLeft: "10px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={detail.suspicious}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "suspicious-yes-checkbox" }}
                    />
                  }
                  label="Yes"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!detail.suspicious}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "suspicious-no-checkbox" }}
                    />
                  }
                  label="No"
                />
              </Grid>
            </Grid>

            <Grid container item xs={12} sm={10} alignItems="center">
              <Grid item>
                <MDTypography variant="h8">Blocked by Nascom</MDTypography>
              </Grid>
              <Grid item style={{ marginLeft: "10px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={detail.blocked}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "blocked-yes-checkbox" }}
                    />
                  }
                  label="Yes"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!detail.blocked}
                      disabled
                      color="primary"
                      inputProps={{ "aria-label": "blocked-no-checkbox" }}
                    />
                  }
                  label="No"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="gradient"
            color="dark"
            onClick={() => {
              handleCancelClick();
              setCandidateNameDialog(false);
            }}
          >
            Cancel
          </Button>
          {permissions?.includes(modulePermissions?.update_permission) && (
            <Button
              variant="gradient"
              color="dark"
              onClick={async () => {
                await handleSaveClick();
              }}
            >
              Update
            </Button>
          )}
          {hasFinalInterview &&
            permissions?.includes(modulePermissions?.update_permission) ? (
            <Button
              variant="gradient"
              color="dark"
              onClick={() => handleDocumentOpen()}
            >
              Provide Job Offer
            </Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}
